module.exports = __webpack_public_path__ + "img/starry.9116eb9b.png";